import { createSlice } from "@reduxjs/toolkit";
import { UPLOAD_MESSAGES } from "../components/ReportEvaluationPage/UploadEvaluation/ConstantMsg";

const initialState = {
  fileName: "",
  fileSizeText: "",
  fileUrl: "",
  bannerMsg: "",
  bannerType: "success",
  openReportModal: false,
  selectedInterviewId: null,
  evaluationMode: "internal",
  reportRequestMessage: null,
};

const reportSlice = createSlice({
  name: "report",
  initialState,
  reducers: {
    setFile: (state, action) => {
      state.fileName = action.payload.name;
      state.fileSizeText = action.payload.sizeText;
      state.fileUrl = action.payload.url;
      state.bannerMsg = UPLOAD_MESSAGES.FILE_SUCCESS;
      state.bannerType = "success";
    },

    removeFile: (state) => {
      state.fileName = "";
      state.fileSizeText = "";
      state.fileUrl = "";
      state.bannerMsg = UPLOAD_MESSAGES.FILE_REMOVED;
      state.bannerType = "success";
    },

    evaluateSuccess: (state) => {
      state.fileName = "";
      state.fileSizeText = "";
      state.fileUrl = "";
      state.bannerMsg = UPLOAD_MESSAGES.EVALUATE_SUCCESS;
      state.bannerType = "success";
    },

    evaluateError: (state, action) => {
      state.bannerMsg =
        action?.payload || UPLOAD_MESSAGES.EVALUATE_ERROR;
      state.bannerType = "error";
    },

    clearBanner: (state) => {
      state.bannerMsg = "";
    },

    setReportModal: (state, action) => {
      state.openReportModal = action.payload;
    },

    setSelectedInterviewId: (state, action) => {
      state.selectedInterviewId = action.payload;
    },

    setEvaluationMode: (state, action) => {
      state.evaluationMode = action.payload;
    },

    setReportRequestMessage: (state, action) => {
      state.reportRequestMessage = action.payload;
    },

    clearReportRequestMessage: (state) => {
      state.reportRequestMessage = null;
    },
  },
});

export const {
  setFile,
  removeFile,
  evaluateSuccess,
  evaluateError,
  clearBanner,
  setReportModal,
  setSelectedInterviewId,
  setEvaluationMode,
  setReportRequestMessage,
  clearReportRequestMessage,
} = reportSlice.actions;

export default reportSlice.reducer;
